// extracted by css-extract-rspack-plugin
export default {"Box":"ChecksStatusBadgeFooter-module__Box__t610omv"};